import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import WSButton from "../Components/Button/WSButton";
import WSTextField, { TextType } from "../Components/TextBox/WSTextBox";
import imgmetro from "../images/metrologin.svg";
import { callAPI, clearRequest, Method } from "../commonFunctions/CommonFunctions";
import { useSnackbar } from "../Components/Snackbar/SnackBarContext";
import backImg from "../images/background.svg";
import logo from "../images/logo.svg";
interface LoginFormProps {
  onLogin: (token: string) => void;
}

export const LoginForm: React.FC<LoginFormProps> = React.memo(({ onLogin }) => {
  const backImgStyle = `url(${backImg})`;
  const { control, register, handleSubmit, formState: { errors } } = useForm();
  const { showMessage } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleData = async (data: any) => {
    try {
      const request = {
        mobileNumber: data.mobileNumber,
        userCode: data.userCode,
        id: data.id,
      };
      const newRequest = clearRequest(request);
      setLoading(true);

      const response: any = await callAPI("Auth/login", Method.POST, newRequest);
      console.log('response s',response);

      if (response && response?.jwtToken) {
        onLogin(response?.jwtToken);
        showMessage("Logged in successfully!", "success");
      } else {
        throw new Error("Login failed. Please try again.");
      }

      // login without server;
    // if (
    //   data?.mobileNumber === "6282422107" &&
    //   data?.userCode === "536298"
    // ) {
    //   const fakeJwtToken = "hardcoded-jwt-token";
    //   onLogin(fakeJwtToken);
    //   showMessage("Logged in successfully!", "success");
    // } else {
    //   throw new Error("Invalid credentials. Please try again.");
    // } 
    } catch (e: any) {
      showMessage(e.message || "An unexpected error occurred.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      sx={{
       
        backgroundImage: `url(${backImg})`,
        backgroundSize: 'cover',
        //backgroundPosition: 'center',
        padding:4,

        borderRadius: "10px",
      }}
    >
      
      {/* Left Side - Image */}
      <Grid
        item
        xs={12}
        sm={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <Box>
          <img
            src={imgmetro}
            alt="Illustration"
            style={{ width: "100%", maxWidth: "500px", height: "32rem" }}
          />
        </Box>
      </Grid>

      {/* Right Side - Login Form */}
      <Grid
        item
        xs={12}
        sm={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 4,
          // backgroundColor: "#fff",
          backgroundImage: backImgStyle,
          borderRadius: "10px",
        }}
      >
          <Box  sx={{ alignContent:'center',alignItems:'center' ,textAlign:'center',  justifyContent: "center",}}>
          <img
            src={logo}
            alt="Illustration"
            
          />
        </Box>
        <br/>
        <form onSubmit={handleSubmit(handleData)}>
          {/* Header */}
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: "#2d3436",
              marginBottom: 3,
            }}
          >
            Login
          </Typography>
          <Typography
            variant="body2"
            sx={{
              textAlign: "center",
              color: "#636e72",
              marginBottom: 4,
            }}
          >
            Please login to your account
          </Typography>

          {/* Login Fields */}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <WSTextField
                label="Mobile Number"
                {...register("mobileNumber", { required: "Mobile number is required" })}
                id="mobileNumber"
                name="mobileNumber"
                control={control}
                maxLength={10}
                labelType="Normal"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
             
            </Grid>
            <Grid item xs={12}>
              <WSTextField
                label="User Code"
                {...register("userCode", { required: "User code is required" })}
                id="userCode"
                name="userCode"
                control={control}
                labelType="Normal"
                type={TextType.Password}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
             
            </Grid>
            <Grid item xs={12}>
              <WSButton
                id="login"
                label="Log In"
                size="large"
                variant="contained"
                type="submit"
                loading={loading}
                sx={{
                  width: "100%",
                  borderRadius: 2,
                  paddingY: 1.5,
                  fontSize: "1rem",
                  background: "linear-gradient(45deg, #447F40, #446C50)",
                  "&:hover": {
                    background: "linear-gradient(45deg, #5F8726, #5F9726)",
                  },
                  color: "#fff",
                  textTransform: "none",
                }}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
});
